var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.29292 14.6392C3.59804 14.3341 4.06447 14.2591 4.44985 14.4532C5.45471 14.9593 6.59037 15.2448 7.79559 15.2448C11.9097 15.2448 15.2448 11.9097 15.2448 7.79556C15.2448 6.59034 14.9594 5.45468 14.4532 4.44982C14.2591 4.06444 14.3341 3.59801 14.6393 3.29289C14.9444 2.98777 15.4108 2.91278 15.7962 3.10688C18.8806 4.66039 21 7.85718 21 11.5508C21 16.7694 16.7695 21 11.5508 21C7.85721 21 4.66041 18.8806 3.10691 15.7962C2.91281 15.4108 2.9878 14.9443 3.29292 14.6392ZM6.66962 17.1783C7.97743 18.3136 9.68433 19 11.5508 19C15.6649 19 19 15.6649 19 11.5508C19 9.68429 18.3137 7.9774 17.1783 6.66959C17.2222 7.03894 17.2448 7.4147 17.2448 7.79556C17.2448 13.0142 13.0143 17.2448 7.79559 17.2448C7.41474 17.2448 7.03898 17.2222 6.66962 17.1783Z",
    fill: "#1E1E1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDark);
export default __webpack_public_path__ + "static/media/dark.f3e3d36f5de7af0ba70da4547241777c.svg";
export { ForwardRef as ReactComponent };